// Generated by littlecrumb. Do not edit.
import { start } from "littlecrumb/client";
import { routes } from "./routes";

start(routes);
